import Select, { PropsValue, SingleValue, Options } from 'react-select';
import { FC, useEffect, useState } from 'react';
import { imageUrl } from '../../../helpers/api';
import clsx from 'clsx';
import ImageUpload from './ImageUpload';
import { ConfirmDialog } from '../ConfirmDialog';
import { updateProvider } from '../../apps/providers/core/_requests';
import { Provider } from '../../../helpers/models';

type Props = {
  onUpdate?: (uuid: string) => void;
  onRemove?: () => void;
  className?: string;
  title?: string;
  disabled?: boolean;
  imageUuid?: string | undefined | null;
  altText?: string;
  allowEdit?: boolean;
  rectangle?: boolean;
  extra?: any;
};

const WizImage: FC<Props> = (props) => {
  const { imageUuid, allowEdit, altText, onUpdate, onRemove, extra, rectangle, title, className } = props;
  const [uploadPhoto, setUploadPhoto] = useState(false);

  return (
    <>
      <div className={className || 'd-flex flex-column align-items-center justify-content-center'}>
        <div
          className={clsx('avatar-container position-relative', { 'cursor-pointer': allowEdit })}
          onClick={() => {
            if (allowEdit) setUploadPhoto(true);
          }}
        >
          {imageUuid ? (
            <img
              className={rectangle ? 'logo-img-rectangle' : 'avatar-img-round'}
              src={imageUrl(imageUuid)}
              alt="img"
            />
          ) : rectangle ? (
            <div className="logo-rectangle cursor-pointer" style={{ width: '400px', height: '100px' }}>
              {altText}
            </div>
          ) : (
            <div className="symbol symbol-circle symbol-100px symbol-fixed">
              <div className="symbol-label fs-1 bg-light-primary border border-4 border-primary text-primary">
                {altText}
              </div>
            </div>
          )}
          {allowEdit && (
            <>
              <div
                className="text-primary avatar-edit-button"
                style={rectangle ? { top: '81%', right: '-5px', left: 'unset' } : undefined}
              >
                <i className="bi bi-camera inherit-color"></i>
              </div>
            </>
          )}
        </div>
      </div>
      {uploadPhoto && (
        <ImageUpload
          show={uploadPhoto}
          imageUuid={imageUuid}
          extra={extra}
          rectangle={rectangle}
          size={rectangle ? 'lg' : undefined}
          title={title || 'Upload Image'}
          onCancel={() => setUploadPhoto(false)}
          onUpdate={(uuid) => {
            if (uuid) onUpdate?.(uuid);
            else onRemove?.();
            setUploadPhoto(false);
          }}
        />
      )}
    </>
  );
};

export { WizImage };
